import { Loc } from 'main.core';
import { NoticeBase } from 'b24network.vue.cross-scenario-shared-js';

/**
 * Invite link is broken or containing incorrect data
 */
export class IncorrectInvite extends NoticeBase
{
	constructor(portalName: string)
	{
		super(
			Loc.getMessage('EXT_B24NET_LOGGING_IN_ADMIN_HAS_DISABLED_INVITE'),
			Loc.getMessage('EXT_B24NET_LOGGING_CANT_CONNECT', {
				'[b]': '<b>',
				'[/b]': '</b>',
				'[br]': '<br>',
				'#PORTAL_NAME#': portalName,
			}),
		);
	}
}
